import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const MutualBox = styled.div`
    right: 20px;
    bottom: 20px;
    position: fixed;
    z-index: 9999;
`;

const PCBox = styled(MutualBox)`
    width: 100px;
`;

const MobileBox = styled(MutualBox)`
    width: 70px;
`;


export const FreeToPlayAnimatedIcon2Box = styledByDevice(PCBox,MobileBox);